import { tableLinksApi } from 'entities/table/api/tableLinksApi';
import { EntityInterface } from 'shared/types/entityInterface';
import { makeAutoObservable, runInAction } from 'mobx';
import { ExplorerEntityTypes } from 'entities/types';

export type TableLinkData = {
  id: string;
  name: string;
  url: string;
  description: string;
};

export class TableLinkModel implements EntityInterface<{ in_trash: boolean }> {
  public type = ExplorerEntityTypes.TABLE as const;
  public isPending = false;
  public isError = false;

  public data: TableLinkData;
  private _id: string;
  public get id() {
    return this._id;
  }

  constructor(data: TableLinkData) {
    this._id = data.id;
    this.data = data;
    makeAutoObservable(this);
  }

  public async fetch() {
    runInAction(() => {
      this.isPending = true;
      this.isError = false;
    });

    try {
      const data = await tableLinksApi.fetch(this._id);

      runInAction(() => {
        this.data = data;
        this.isPending = false;
      });
    } catch (e) {
      runInAction(() => {
        this.isPending = false;
        this.isError = true;
      });
      console.error(e);
    }
  }
}
